import { useRef, useEffect } from 'react';
import { Location } from 'history';
import { useLocation } from 'react-router-dom';

export function usePreviousLocation() {
  const previous = useRef<Location | null>(null);
  const location = useLocation();
  useEffect(() => {
    previous.current = location;
  });
  return previous.current;
}
